import React from "react"

const FaUserMagnifying = (props) => {
  const { width, height, style } = props
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width={width} height={height} style={style} viewBox="0 0 96.000000 96.000000"
      preserveAspectRatio="xMidYMid meet" className="faUserMagnifying" >

      <g transform="translate(-5.000000,94.000000) scale(0.048000,-0.048000)"
      stroke="none">
      <path d="M715 1786 c-118 -29 -207 -102 -262 -214 -36 -72 -38 -81 -38 -172 0
      -91 2 -100 38 -172 60 -121 157 -195 291 -219 260 -48 498 188 455 453 -37
      230 -260 379 -484 324z m190 -155 c96 -43 155 -132 155 -230 -1 -183 -191
      -305 -355 -227 -97 46 -145 121 -145 226 0 33 7 77 16 98 50 120 213 186 329
      133z"/>
      <path d="M1430 1189 c-108 -21 -217 -101 -268 -196 -131 -246 7 -534 280 -584
      79 -14 168 -1 243 36 l50 25 130 -129 c72 -71 140 -132 151 -135 52 -16 101
      41 82 94 -5 14 -66 82 -135 152 -123 123 -126 127 -111 150 39 61 61 174 48
      253 -27 167 -153 299 -318 334 -60 12 -88 13 -152 0z m175 -158 c96 -43 155
      -132 155 -230 -1 -172 -162 -288 -334 -240 -50 14 -124 83 -149 139 -24 54
      -26 140 -5 191 54 127 214 195 333 140z"/>
      <path d="M573 839 c-119 -20 -248 -91 -323 -177 -57 -66 -108 -174 -127 -268
      -20 -105 -13 -148 30 -174 31 -19 55 -20 659 -20 l628 0 29 27 c17 16 31 37
      33 48 3 17 -5 20 -53 27 -31 4 -83 16 -115 27 -56 20 -80 21 -567 21 l-509 0
      7 33 c23 114 132 244 242 288 53 22 76 24 283 27 l225 3 -3 75 -4 74 -191 -1
      c-106 -1 -215 -5 -244 -10z"/>
      </g>
      </svg>


   
  )
}

export default FaUserMagnifying